export const paymentCredentialsUpdated = value => ({
    type: 'PAYMENT_CREDENTIALS_UPDATED',
    value
});

export const orderUpdating = value => ({
    type: 'ORDER_UPDATING',
    value
})
